import { cn } from '@/lib/utils'

type TacticalCardProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
  className?: string
  variant?: 'default' | 'accent' | 'muted' | 'error'
  padding?: 'none' | 'sm' | 'default' | 'lg'
  interactive?: boolean
}

const variantStyles = {
  default: 'border-white/[0.06] bg-white/[0.02]',
  accent: 'border-primary/20 bg-primary/[0.03]',
  muted: 'border-white/[0.04] bg-white/[0.01]',
  error: 'border-destructive/20 bg-destructive/[0.03]',
}

const paddingStyles = {
  none: '',
  sm: 'px-3 py-2',
  default: 'px-4 py-3',
  lg: 'px-6 py-4',
}

export function TacticalCard({
  children,
  className,
  variant = 'default',
  padding = 'default',
  interactive = false,
  ...rest
}: TacticalCardProps) {
  return (
    <div
      className={cn(
        'border rounded-lg transition-all duration-150',
        variantStyles[variant],
        paddingStyles[padding],
        interactive && 'cursor-pointer hover:bg-white/[0.04] hover:border-white/[0.1] active:bg-white/[0.05]',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

export function TacticalCardHeader({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'font-medium text-sm text-foreground',
        className
      )}
    >
      {children}
    </div>
  )
}

export function TacticalCardSection({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div className={cn('mt-3 pt-3 border-t border-border/10', className)}>
      {children}
    </div>
  )
}
